import React from 'react';
import { Card, Skeleton, SkeletonAvatar } from '@parsina/framework';
import { SkeletonPage } from '../../components/common/skeletons.jsx';

// بیماران — the loading shape of the register.
//
// Only the MOBILE list skeletons: the page header and the search card are real
// chrome that stays operable while the first page loads (DESIGN.md §"Loading &
// skeleton", "Region load"). A later page never comes through here at all —
// the rows stay on screen and dim (§7, stale-while-refetch).
//
// The desktop has no skeleton of its own any more: it renders the REAL `Table`
// with `loading`, so the header, the four column widths and the sort chrome are
// the real ones and only the body is placeholder. See Patients.web.jsx.

/** MobilePatientCard: 36px avatar · name/sub · a phone/file-number meta row. */
const MobileRowSkeleton = ({ i }) => (
  <Card aria-hidden style={{ padding: '0.75rem', marginBottom: '0.5rem', borderRadius: '0.875rem' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem' }}>
      <SkeletonAvatar size={36} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 5 }}>
        <Skeleton width={`${40 + ((i * 17) % 35)}%`} height={14} />
        <Skeleton width="30%" height={11} />
      </div>
    </div>
    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem' }}>
      <Skeleton width={110} height={11} />
      <Skeleton width={72} height={11} />
    </div>
  </Card>
);

export const PatientsSkeletonMobile = ({ label, rows = 6 }) => (
  <SkeletonPage label={label} data-testid="patients-skeleton">
    {Array.from({ length: rows }, (_, i) => <MobileRowSkeleton key={i} i={i} />)}
  </SkeletonPage>
);
